import React from 'react';
import { Redirect, useParams } from 'react-router';
import { PageLoading } from 'components/atoms/loading';
import { EditAutomation } from 'components/organisms/module-settings/integrations/integrations-list/salesforce/automation/create/edit';
import { RoutePaths } from 'constant';
import { useSalesForceAutomationsDetails } from 'queries/salesforce-integration';

export const AutomationsEditPage = () => {
  const { integrationId, automationId } =
    useParams<{ integrationId: string; automationId: string }>();

  const { data: automationById, status } = useSalesForceAutomationsDetails(
    Number(automationId),
    {
      onError: () => {
        return <Redirect push to={RoutePaths.salesforceIntegrations} />;
      },
    },
  );

  if (
    Number.isNaN(Number(integrationId)) ||
    Number.isNaN(Number(automationId))
  ) {
    return <Redirect push to={RoutePaths.salesforceIntegrations} />;
  }

  switch (status) {
    case 'loading': {
      return <PageLoading />;
    }

    case 'success': {
      return automationById ? (
        <EditAutomation
          integrationId={Number(integrationId)}
          automationById={automationById}
        />
      ) : null;
    }

    case 'idle':
    case 'error':
    default: {
      return <></>;
    }
  }
};
